module.exports = __webpack_public_path__ + "img/imgexhangedbt.ffe1ed2c.png";